
import { 
  addWeeks, 
  subWeeks, 
  addMonths, 
  subMonths 
} from 'date-fns';

export function getNextDate(currentDate: Date, viewType: 'week' | 'month' | 'list'): Date {
  if (viewType === 'month') {
    return addMonths(currentDate, 1);
  } else {
    return addWeeks(currentDate, 1);
  }
}

export function getPreviousDate(currentDate: Date, viewType: 'week' | 'month' | 'list'): Date {
  if (viewType === 'month') {
    return subMonths(currentDate, 1);
  } else {
    return subWeeks(currentDate, 1);
  }
}

export function openVideo(videoId?: string): void {
  if (videoId) {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  }
}
